import { render, staticRenderFns } from "./Firms.vue?vue&type=template&id=09f3f8d2&scoped=true&"
import script from "./Firms.vue?vue&type=script&lang=js&"
export * from "./Firms.vue?vue&type=script&lang=js&"
import style0 from "./Firms.vue?vue&type=style&index=0&id=09f3f8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3f8d2",
  null
  
)

export default component.exports